import { digit } from "./digit"
import { system } from "./system"
import { supplier } from "./supplier"
import { partner } from "./partner"
import { logistics } from "./logistics"
export const routerAll = [
    {
        path: '/user',
        name: '控制台',
        redirect: 'home',
        component: () => import("@/views/layout/index.vue"),
        isShow:false,
        children: [
            {
                path: 'home',
                component: () => import("@/views/sellerAdmin/home/index.vue"),
                name: '控制台',
                meta: {
                    hidden: true,
                    user: 0,
                },
            },
        ]
    },
    ...digit,
    ...system,
    ...partner,
    ...logistics,
    ...supplier,
]